import { createFileRoute, redirect } from '@tanstack/react-router';

import { EuTaxonomySectionPage } from '@/features/eu-taxonomy/components/EuTaxonomySectionPage';
import { getEuTaxonomySection, isEuTaxonomySection } from '@/features/eu-taxonomy/config';

export const Route = createFileRoute('/_authenticated/eu-taxonomy/$section')({
  beforeLoad: ({ params }) => {
    if (params.section === 'onboarding') {
      // TanStack Router expects redirect to be thrown as control flow.
      // eslint-disable-next-line @typescript-eslint/only-throw-error
      throw redirect({ to: '/eu-taxonomy/activity-identification' });
    }

    if (!isEuTaxonomySection(params.section)) {
      // TanStack Router expects redirect to be thrown as control flow.
      // eslint-disable-next-line @typescript-eslint/only-throw-error
      throw redirect({ to: '/eu-taxonomy/overview' });
    }

    return {
      getTitle: () => getEuTaxonomySection(params.section).title,
    };
  },
  component: EuTaxonomySectionRoute,
});

function EuTaxonomySectionRoute() {
  const { section } = Route.useParams();

  if (!isEuTaxonomySection(section)) {
    return null;
  }

  return <EuTaxonomySectionPage sectionId={section} />;
}
